import { makeVar } from '@apollo/client/cache'

export const isFederalDealQueryVar = makeVar<boolean>(false)

export const setIsFederalDealQueryVar = (isFederalQuery: boolean) =>
  isFederalDealQueryVar(isFederalQuery)
